@if (file && printSettings) {
  <div class="files-container flex flex-col gap-2.5 p-[15px]">
    <div class="flex flex-row justify-between">
      <div class="flex flex-row items-center gap-2.5">
        <img class="file-img" src="{{ file.thumbFile?.url }}" alt="" />
        <div class="flex flex-col gap-[5px]">
          <span class="file-name">{{ file.alias }}</span>
          <span class="file-pages">Nº Páginas: {{ file.pages }}</span>
        </div>
      </div>

      <div class="grid grid-flow-col grid-rows-2 justify-items-end">
        @if (warningMessage !== '') {
          <ion-icon
            id="warning"
            class="warning-icon row-start-1"
            src="../../../../assets/icon/alert-yellow.svg"
          ></ion-icon>
          <ion-popover class="warning-popover" trigger="warning">
            <ng-template>
              <div class="flex flex-col gap-[15px]">
                <span class="warning-title">Encuadernado</span>
                <span class="warning-message">{{ warningMessage }}</span>
              </div>
            </ng-template>
          </ion-popover>
        }
        <ion-button
          class="view-details-button row-start-2 flex w-fit items-center justify-center"
          fill="clear"
          size="small"
          (click)="toggleViewDetails()"
        >
          <span>{{ viewDetails ? 'ocultar detalles' : 'ver detalles' }}</span>
          <ion-icon
            [ngClass]="{ '-scale-y-100': viewDetails }"
            src="../../../../assets/icon/flechaAbajo.svg"
          ></ion-icon>
        </ion-button>
      </div>
    </div>

    @if (!viewDetails) {
      @if (printingGroup.binding) {
        <div class="file-info-wrapper">
          <div class="binding-settings details-container flex w-full flex-row items-center gap-[15px]">
            <div class="flex flex-row items-center gap-[5px]">
              <img
                class="ring-img"
                [src]="'assets/images/binding/rings/' + bindingOptionValueForFile('ringColor', 'id') + '.png'"
              />
              <div class="flex flex-row gap-0.5">
                <span class="binding-text" [ngClass]="{ noStock: false }">
                  Anillas: {{ bindingOptionValueForFile('ringColor', 'name') }}
                </span>
              </div>
            </div>

            @if (showCovers()) {
              <div class="flex flex-row items-center gap-[5px]">
                <app-cover-thumbnail
                  [id]="bindingOptionValueForFile('hardCoverFront', 'id')"
                  [color]="bindingOptionValueForFile('hardCoverFront', 'color')"
                  [width]="'20px'"
                  [height]="'24px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-row gap-0.5">
                  <ng-container *ngIf="!printSettings.coverLaminated">
                    <span class="binding-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverFront }">
                      Tapa delantera: {{ utils.getColorName(bindingOptionValueForFile('hardCoverFront', 'name')) }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="printSettings.coverLaminated">
                    <span class="binding-text bold coverColorTag">
                      Portada {{ fileService.getLaminationTypeName(printSettings.laminationType) }},
                      {{
                        fileService.getLaminationWeightName(
                          printSettings.laminationWeight,
                          printSettings.laminationType,
                          printSettings.coverLaminated
                        )
                      }}
                      <span *ngIf="!printSettings.coverLaminated"
                        >({{ printSettings.laminationWeight }} micras)</span
                      > </span
                    >&nbsp;
                  </ng-container>
                </div>
              </div>

              <div class="flex flex-row items-center gap-[5px]">
                <app-cover-thumbnail
                  [id]="bindingOptionValueForFile('hardCoverBack', 'id')"
                  [color]="bindingOptionValueForFile('hardCoverBack', 'color')"
                  [width]="'20px'"
                  [height]="'24px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-row gap-0.5">
                  <span class="binding-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverBack }">
                    Tapa trasera: {{ utils.getColorName(bindingOptionValueForFile('hardCoverBack', 'name')) }}
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div class="file-info-wrapper flex flex-col gap-[5px]">
        @if (printingGroup.binding) {
          <div class="binding-settings details-container flex w-full flex-row items-center gap-[15px] p-2.5">
            <div class="flex flex-row items-center gap-[5px]">
              <img
                class="ring-img"
                [src]="'assets/images/binding/rings/' + bindingOptionValueForFile('ringColor', 'id') + '.png'"
              />
              <div class="flex flex-row gap-0.5">
                <span class="binding-text" [ngClass]="{ noStock: false }">
                  Anillas: {{ bindingOptionValueForFile('ringColor', 'name') }}
                </span>
              </div>
            </div>

            @if (showCovers()) {
              <div class="flex flex-row items-center gap-[5px]">
                <app-cover-thumbnail
                  [id]="bindingOptionValueForFile('hardCoverFront', 'id')"
                  [color]="bindingOptionValueForFile('hardCoverFront', 'color')"
                  [width]="'20px'"
                  [height]="'24px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-row gap-0.5">
                  <ng-container *ngIf="!printSettings.coverLaminated">
                    <span class="binding-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverFront }">
                      Tapa delantera: {{ utils.getColorName(bindingOptionValueForFile('hardCoverFront', 'name')) }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="printSettings.coverLaminated">
                    <span class="binding-text bold coverColorTag">
                      Portada {{ fileService.getLaminationTypeName(printSettings.laminationType) }},
                      {{
                        fileService.getLaminationWeightName(
                          printSettings.laminationWeight,
                          printSettings.laminationType,
                          printSettings.coverLaminated
                        )
                      }}
                      <span *ngIf="!printSettings.coverLaminated"
                        >({{ printSettings.laminationWeight }} micras)</span
                      > </span
                    >&nbsp;
                  </ng-container>
                </div>
              </div>

              <div class="flex flex-row items-center gap-[5px]">
                <app-cover-thumbnail
                  [id]="bindingOptionValueForFile('hardCoverBack', 'id')"
                  [color]="bindingOptionValueForFile('hardCoverBack', 'color')"
                  [width]="'20px'"
                  [height]="'24px'"
                >
                </app-cover-thumbnail>
                <div class="flex flex-row gap-0.5">
                  <span class="binding-text" [ngClass]="{ noStock: withoutStock[file?.id]?.hardCoverBack }">
                    Tapa trasera: {{ utils.getColorName(bindingOptionValueForFile('hardCoverBack', 'name')) }}
                  </span>
                </div>
              </div>
            }
          </div>
        }

        <!-- Portada -->
        @if (![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(printSettings.finishing)) {
          <div class="details-container flex flex-col gap-[5px]">
            <span class="text-base font-normal">Portada:</span>
            <div class="flex flex-col gap-[5px]">
              <div class="flex flex-row items-center gap-2.5">
                <img
                  class="coverTypeIcon"
                  [src]="
                    fileService.getCoverTypeImage(file.coverType, {
                      docColor: file.docColor,
                      twoSided: printSettings.twoSided,
                      pagesPerSheet: printSettings.pagesPerSheet,
                    })
                  "
                  alt=""
                />
                <span class="cover-text">
                  {{ getCoverTypeSetting(file).title + (getCoverTypeSetting(file).value.twoSided ? '' : ', una cara') }}
                </span>
              </div>

              <div class="annotations-row flex flex-row flex-wrap items-center gap-[5px]">
                @if (
                  ![finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(printSettings.finishing)
                ) {
                  <span class="blue"
                    >{{ file.coverLaminated ? printSettings.paperWeight : file.coverType.paperWeight }} gr</span
                  >
                }
                @if (printSettings.twoSided && getCoverTypeSetting(file).value.twoSided) {
                  <span class="yellow">Sin despaginación</span>
                }
                @if (printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided) {
                  <span class="pink">Con despaginación</span>
                }
                @if (printSettings.twoSided && !getCoverTypeSetting(file).value.twoSided) {
                  <span class="pink">Desconfigura tu documento</span>
                }
              </div>
            </div>
          </div>
        }

        <div class="details-container flex flex-row items-center gap-[5px]">
          <ion-icon
            class="text-lg"
            [src]="file.docColor ? 'assets/icon/color-indicator.svg' : 'assets/icon/black-white-indicator.svg'"
          ></ion-icon>
          <span class="file-color"> {{ file.docColor ? 'Interior en color' : 'Interior en blanco y negro' }}</span>
        </div>

        @if ([finishing.LAMINATED, finishing.LAMINATEDA4, finishing.LAMINATEDA3].includes(printSettings.finishing)) {
          <div class="details-container flex flex-row items-center gap-2.5 text-base">
            <div class="flex flex-row items-center gap-1.5">
              <img
                [src]="
                  file.laminationType === 'gloss'
                    ? '../../../assets/images/finishings/brillo.png'
                    : '../../../assets/images/finishings/mate.png'
                "
                alt=""
              />
              <span> Plastificado {{ fileService.getLaminationTypeName(file.laminationType) }} </span>
            </div>

            <span class="text-gray-700">|</span>

            <span
              >{{
                fileService.getLaminationWeightName(file.laminationWeight, file.laminationType, file.coverLaminated)
              }}
              <span *ngIf="!file.coverLaminated">({{ file.laminationWeight }} micras)</span></span
            >
          </div>
        }

        <div class="details-container flex flex-col gap-2.5">
          <div class="flex flex-row items-center justify-between gap-2.5">
            <span class="blank-sheets-text">Folios en blanco por <span>DELANTE:</span></span>
            <span class="blank-sheets-number">{{ file.blankSheetsBefore || 0 }}</span>
          </div>

          <div class="flex flex-row items-center justify-between gap-2.5">
            <span class="blank-sheets-text">Folios en blanco por <span>DETRÁS:</span></span>
            <span class="blank-sheets-number">{{ file.blankSheetsAfter || 0 }}</span>
          </div>
        </div>
      </div>
    }
  </div>
}
